import { useEffect, useState } from 'react';
import { Badge, Button, Card, Input } from '../design-system/components';
import { api } from '../lib/api';

interface Ticket {
  id: string;
  subject: string;
  status: 'open' | 'pending' | 'resolved';
  createdAt: string;
}

export function Support() {
  const [tickets, setTickets] = useState<Ticket[]>([]);
  const [subject, setSubject] = useState('');
  const [body, setBody] = useState('');
  const [sent, setSent] = useState(false);

  async function load() {
    setTickets((await api<{ tickets: Ticket[] }>('/api/support/tickets')).tickets);
  }
  useEffect(() => {
    load().catch(() => undefined);
  }, []);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    await api('/api/support/tickets', { method: 'POST', body: JSON.stringify({ subject, body }) });
    setSubject('');
    setBody('');
    setSent(true);
    setTimeout(() => setSent(false), 2000);
    await load();
  }

  return (
    <div className="kz-stack" style={{ gap: 'var(--space-6)', maxWidth: 640 }}>
      <div>
        <span className="kz-eyebrow">Help & support</span>
        <h1 style={{ marginTop: 'var(--space-1)' }}>We're here to help</h1>
      </div>

      <Card>
        <form className="kz-stack" onSubmit={submit}>
          <Input label="Subject" value={subject} onChange={(e) => setSubject(e.target.value)} minLength={3} required />
          <div>
            <label className="kz-field-label">How can we help?</label>
            <textarea
              value={body}
              onChange={(e) => setBody(e.target.value)}
              minLength={5}
              rows={4}
              required
              style={{ width: '100%', font: 'var(--type-body)', border: 'var(--border-width) solid var(--border-default)', borderRadius: 'var(--radius-md)', padding: '11px 14px' }}
            />
          </div>
          <Button type="submit">Send to support</Button>
          {sent && <p style={{ color: 'var(--safe-700)', font: 'var(--type-small)' }}>Thanks! We'll get back to you.</p>}
        </form>
      </Card>

      <div className="kz-stack">
        {tickets.map((t) => (
          <Card key={t.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span>{t.subject}</span>
            <Badge tone={t.status === 'resolved' ? 'safe' : 'warn'}>{t.status}</Badge>
          </Card>
        ))}
      </div>
    </div>
  );
}
